export enum Property {
    ItemSettingReport = 'item_setting_report',
    ListSettingReport = 'list_setting_report',
}
